import request from '@/util/request';
import qs from 'qs';
//房产树一级节点
export const getSmartDevicePage = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart-device/page',
    Object.assign({}, options, {
      params
    })
  );

export const smartDeviceSave = (params, options) =>
  request.post('/api/v4ward/nursinghome/smart-device/save', params, options);

export const smartDeviceUpdate = (params, options) =>
  request.post('/api/v4ward/nursinghome/smart-device/update', params, options);

  export const getSmartDeviceDetail = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart-device/detail',
    Object.assign({}, options, {
      params
    })
  );
//设备履历-设备信息
export const getSmartDeviceResumeBasicInfo = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart-device/resume/basicInfo',
    Object.assign({}, options, {
      params
    })
  );

//报废
export const smartDeviceScrap = (params, options) =>
  request.post('/api/v4ward/nursinghome/smart-device/scrap', params, options);
//设备履历-使用者信息
export const getSmartDeviceResumeElderlyInfo = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart-device/resume/elderlyInfo',
    Object.assign({}, options, {
      params
    })
  );

//设备履历-维修记录列表
export const getSmartDeviceResumeRepairlist = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart-device/resume/repair/list',
    Object.assign({}, options, {
      params
    })
  );

//设备履历-维修新增
export const smartDeviceResumeRepairSave = (params, options) =>
  request.post('/api/v4ward/nursinghome/smart-device/repair/save', params, options);


//设备履历-保养记录列表
export const getSmartDeviceResumeUpkeeplist = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart-device/resume/upkeep/list',
    Object.assign({}, options, {
      params
    })
  );

//设备履历-保养新增
export const smartDeviceResumeUpkeepSave = (params, options) =>
  request.post('/api/v4ward/nursinghome/smart-device/upkeep/save', params, options);


//设备数据-参数配置
export const getSmartDeviceDataConfig = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart-device/data/config',
    Object.assign({}, options, {
      params
    })
  );

//设备数据-定位数据
export const getSmartDeviceDataLocation = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart-device/data/location',
    Object.assign({}, options, {
      params
    })
  );

//设备数据-健康数据
export const getSmartDeviceDataHealth = (params, options) =>
  request.get(
    '/api/v4ward/nursinghome/smart-device/data/health',
    Object.assign({}, options, {
      params
    })
  );


  
export const nursinglist = (params, options) =>
request.get(
  '/api/nursing/basicInfor/nursinglist',
  Object.assign({}, options, {
    params
  })
);

//解绑
export const smartDeviceUnbind = (id) =>
  request.post('/api/v4ward/nursinghome/smart-device/unbind?id='+id);


  export const getSmartDeviceDataAlert = (params, options) =>
request.get(
    '/api/v4ward/nursinghome/smart-device/data/alert',
  Object.assign({}, options, {
    params
  })
);

export const getDicList = (params, options) =>
request.get(
    '/api/blade-system/dict/list',
  Object.assign({}, options, {
    params
  })
);


export const modelListByTypeId = (params, options) =>
request.get(
    '/api/nursing/deviceModel/modelListByTypeId',
  Object.assign({}, options, {
    params
  })
);

export const deviceOrderPage = (params, options) =>
request.get(
    '/api/v4ward/nursinghome/device-order/page',
  Object.assign({}, options, {
    params
  })
);

// 智能设备数据-机器人任务列表
export const getRebotTaskList = (params, options) =>
  request.get('/api/nursing/robot/task/list', Object.assign({}, options, { params }));

// 智能设备数据-一体机检测列表
export const getIntegratedMachineDetectionList = (params, options) =>
  request.get('/api/nursing/device/elderly/page', Object.assign({}, options, { params }));

// 智能设备数据-一体机详细的检验项目
export const getIntegratedMachineDetectionDetail = (params, options) =>
  request.get('/api/nursing/device/elderly/exam/list', Object.assign({}, options, { params }));

